<div class="circle-container" *ngIf="loading">
  <div class="circle">
    <ts-loading-attribute></ts-loading-attribute>
  </div>
</div>

<div class="circle-container" *ngIf="!loading && count > 1">
  <div class="circle">
    <ts-loading-attribute [value]="'+' + (count - 1)"></ts-loading-attribute>
  </div>
</div>
